import { queuedFetch } from '../utils/requestQueue';

import { API_ENDPOINTS } from '@/shared/api/endPoints';

export default async function getImageUrl(imagePath: string) {
  try {
    const data = await queuedFetch(
      `${API_ENDPOINTS.IMAGE_URL}?path=${imagePath}`,
    );

    return data.json();
  } catch (e) {
    console.log(e);
  }
}
